import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPublic from "../../services/axios/axiosPublic";

export const fetchverifyTokenDetails = createAsyncThunk('getverifyTokenDetails/fetchverifyTokenDetails',
  async (token, { rejectWithValue }) => {
    try {
      const url = `${api.verifyToken}${token}`;
      const response = await axiosPublic.get(url)
      return response.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server")
    }
  })

const verifyTokenSlice = createSlice({
  name: 'TokenDetails',
  initialState: {
    TokenDetails: '',
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders.
      addCase(fetchverifyTokenDetails.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchverifyTokenDetails.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.TokenDetails = action.payload;
        })
      .addCase(fetchverifyTokenDetails.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        });
  }
})

export default verifyTokenSlice.reducer;